import React, { type ReactNode } from "react";
import { CopyButton } from "src/shared/components/CopyButton";
import {
  FlexChild,
  FlexContainer,
} from "src/shared/components/styled/FlexComponents";

export interface CopyableValueProps {
  children: ReactNode;
  copyValue: string;
}

export const CopyableValue = ({ children, copyValue }: CopyableValueProps) => {
  return (
    <FlexContainer inline width="100%">
      <FlexChild grow={1}>{children}</FlexChild>
      <CopyButton value={copyValue} />
    </FlexContainer>
  );
};
